import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./MittiReports.css";
import axios from "axios";
import { config } from "../../../confi";
import Edit_form from "./Edit_form";
import Spinner from "../../Loader/Spinner";
import Modals from "./../../Modal/Modal"

function reverseDateString(dateString) {
  // Split the string into an array using '-' as the separator
  const dateArray = dateString.split('-');

  // Reverse the order of the elements in the array
  const reversedDateArray = dateArray.reverse();

  // Join the elements of the reversed array into a string using '-' as the separator
  const reversedDateString = reversedDateArray.join('-');

  return reversedDateString;
}




function MittiReports() {
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setmsg] = useState(false);
  const [member_reciet_no, Setmember_reciet_no] = useState("");
  const [member_data, setmember_data] = useState(false);

  const [alldata, setAllData] = useState([])

  const handleInputChange = (e) => {
    Setmember_reciet_no(e.target.value);
  };



  // ----------state lift for UI toggle ---------------------
  const datapass = (obj) => {

    setmember_data(obj)
    setShow2(true)
    setShow(false)

  }






  const FetchHandler = async () => {


    setShow2(false)

    if (member_reciet_no.length === 0) {
      return;
    }

    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fe_mi_me",
      payload: { member_reciet_no: member_reciet_no },
    });


    try {
      setLoading(true);
      setShow(false);

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      // console.log(response.data);

      if (response.status === 200 && response.data.status === "0") {
        if (response.data.data.length > 0) {
          // console.log(response.data.data);
          // setmember_data(response.data.data);
          setAllData(response.data.data)
          setShow(true);
        } else {
          setmsg("Not Miti Found");
        }
      } else {
      }
    } catch (error) { }
    setLoading(false);
  };

  //-------------------------  reload component function  after delete function  call  -----------------------//
  
  const [retriger, setRetriger] = useState(Date.now())
  function reload_fn() {
    console.log('triger call')
    setRetriger(Date.now())

  }


  useEffect(() => {
    FetchHandler()

  }, [retriger])

  ///---------------  confirm modal  logic  -------------------------------------------------------------------------///



  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modal_data,setModal_date]  = useState([])
  const [miti_id,setMiti_id] = useState('')
  const [modal_msg,SetModal_msg] = useState('')

  const handleOpenModal = (data,id,msg) => {
    setModal_date(data)
    setMiti_id(id)
    SetModal_msg(msg)

    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirm = () => {
    // Handle the confirm action here
    
    console.log('Confirmed!');
    setIsModalOpen(false);
    miti_delete(miti_id)

  };




 async function miti_delete (id) {

try{ 
     setLoading(true)
     setShow(false)  

  let reqbody = JSON.stringify({
    fn: "common_fun",
    an: "de_mi",
    payload: { miti_id: id },
  });

  const response = await axios.post(
    `${config.apiBaseURL}/root`,
    { data: reqbody },
    {
      headers: { "Content-Type": "application/json" },
    }
  );

 if(response.status ===200 && response.data.status ==='0'){
  setRetriger(Date.now())
  setLoading(false)
  setShow(true) 

 }

 else{
  setmsg("failed please try again")
  setLoading(false)

 }


}

catch(err){
console.log(err)
setmsg("failed please try again")
setLoading(false)
}




 }















  return (
    <>
      {loading ? (
        <span className="loading">
          <Spinner />
        </span>
      ) : (
        <div>
          {msg ? (
            <p className="msg" style={{ color: "red" }}>
              {msg}
            </p>
          ) : (
            <div className="MittiDetails">
              <div className="button-MittiDetails">
                <button>Mitti Report</button>
              </div>
              <div className="book">
                <span>View Miti Detail</span>
              </div>
              <div className="Fetch-Receipt">
                <div>
                  <label className="MittiDetails-label" htmlFor="Receipt-No">
                    Membership Receipt No
                  </label>
                  <br></br>
                  <div className="need-Fetch-Receipt">
                    <input
                      className="MittiDetails-input"
                      id="Receipt-No"
                      type="text"
                      value={member_reciet_no}
                      onChange={handleInputChange}
                    />
                    <button className="fetch-button" onClick={FetchHandler}>
                      Fetch
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}



        </div>
      )}
      {/* 
      {show && <Edit_form Data={member_data} />} */}


      { isModalOpen&& <Modals msg ={modal_msg} data = {modal_data} cancel_fun ={handleCloseModal} confirm_fn ={handleConfirm}/>}
      {show && <Edit_list allmiti={alldata} fun2={datapass} fn_reload={reload_fn} openmodal_fun={handleOpenModal}/>}
      {show2 && <Edit_form Data={member_data} reload_fn ={reload_fn} datapass= {datapass} setmember_data={setmember_data} />}
     
   

    </>
  );
}

export default MittiReports;

//------------------------------------------------------------------------------------------------------------------------------------------//

function Edit_list(prop) {


  //  console.log(prop)
  const [loading, setLoading] = useState(false);
  const [miti, Setmiti] = useState(prop.allmiti)

  //---------------- select - btn handler ---------------------
  const buttonhandeler = (obj) => {

    // console.log(obj)

    prop.fun2(obj)
  }









// -----------------delete handler ----------------
  const delete_btn_handler = async (Id) => {

 
    let reqbody2 = JSON.stringify({
      fn: "common_fun",
      an: "fo_da_mi",
      payload: { miti_id: Id },
    });


    try {
      setLoading(true)

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody2 },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

if(response.status === 200 && response.data.status ==='0'){



      if (response.data.dates.length) {
        // window.confirm("are you going to delete this miti but it have associate display dates  ")
        // console.log('ok')
        prop.openmodal_fun(response.data.dates,Id,'Are you going to delete this Miti but it associated with following display dates so display date will also delete')
       
      }
      else{

        prop.openmodal_fun([],Id,'are you going to delete this miti')

      }
    } 
      
     }
    catch (err) {

      console.log(err)
      setLoading(false)

    }


    setLoading(false)
  }



  
  return (
    <div>

      {
        loading ? <Spinner /> :



         <div className="editlist">

  
            <table>
              <tr>
                <td><b>Name:</b> {prop.allmiti[0].name_person
                }  &nbsp; &nbsp; &nbsp;   <b>Father/husband:</b> {prop.allmiti[0].father_hus_name

                  }</td>
              </tr>

              <tr>

                <th>date</th>
                <th> total amount</th>
                <th>balance</th>
                <th>Action</th>
              </tr>

              {

                miti.map((e, i) => {



                  return <tr key={i}>
                    <td>{reverseDateString(e.miti_create_date.split("T")[0])}</td>
                    {/* <td>{e.total_amount}</td> */}
                    <td>{e.commit_amount?e.commit_amount
:e.total_amount}</td>
                    <td>{e.balance}</td>
                    <td>
                      &nbsp; &nbsp;
                      <button onClick={() => {

                        buttonhandeler(e)

                      }}>select</button>
                      &nbsp;&nbsp;&nbsp;

                      <button onClick={() => {
                        delete_btn_handler(e.miti_row)
                      }}> Delete</button>

                    </td>

                  </tr>

                })

              }
            </table>



          </div>
}


    </div>
    



  )
}